import { useSelector } from 'react-redux';

import { IS_DEMO_LOGIN } from '../../common/constants';
import { useSiteCapabilityCheck } from '../../common/hooks/use-site-capability-check';
import { useGetSiteConsentByTypeQuery } from '../site/new-user-journey/consentApi';
import { selectSite } from '../site/siteSlice';
import { selectUser } from '../user/userSlice';

export const useOnboardingWizardProgress = () => {
  const site = useSelector(selectSite);
  const user = useSelector(selectUser);
  const isSystemOwner = user.role === 'SYSTEM_OWNER';

  const { data: shareDataWithInstallerConsent, isLoading: isSiteConsentsLoading } =
    useGetSiteConsentByTypeQuery('SHARE_WITH_INSTALLER');

  const { siteHasInverter, siteHasAylaSwitches, isLoading: isSiteCapabilityCheckLoading } = useSiteCapabilityCheck();

  return {
    needsSiteAddress: !site.address,

    // This consent needs to be provided by the user if they are the system owner and the site has not yet provided it
    needsToProvideInstallerConsent: isSystemOwner && !shareDataWithInstallerConsent,

    // At least one device is required to be configured
    needsToConfigureHardware: !IS_DEMO_LOGIN && !site.devices.length && !siteHasAylaSwitches,

    // This will be used only when moving from the configure hardware page to the tariffs page
    needsToVisitTariffs: !IS_DEMO_LOGIN && site.isOnboarding,

    // Only show this if the site has a Saturn inverter and user is moving from tariffs page to energy modes page
    needsToVisitEnergyModes: !IS_DEMO_LOGIN && site.isOnboarding && siteHasInverter,

    isLoaded: !isSiteConsentsLoading && !isSiteCapabilityCheckLoading,
  };
};
